import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { MemberStreaksResponse } from './types';

export async function getMemberStreaks(memberId: string) {
  const url = `/web/studio/users/${memberId}/streaks`;

  const response = await api.executeGetRequest<ObjectResponse<MemberStreaksResponse>>(url);

  return response.data;
}
